"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withVisitedOffersContext = exports.useVisitedOffersContext = exports.VisitedOffersContext = void 0;
var _reactUtils = require("@cian/react-utils");
const {
  Context: VisitedOffersContext,
  useContext: useVisitedOffersContext,
  withContext: withVisitedOffersContext
} = (0, _reactUtils.makeContextModule)({
  contextName: 'VisitedOffersContext'
});
exports.withVisitedOffersContext = withVisitedOffersContext;
exports.useVisitedOffersContext = useVisitedOffersContext;
exports.VisitedOffersContext = VisitedOffersContext;